









import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import YouTubePlayer from 'youtube-player';

export default Vue.extend({
  components: { Icon },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    videoPlaylistId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      player: {} as any,
    };
  },
  watch: {
    active(isActive) {
      if (isActive) this.openVideo();
    },
  },
  methods: {
    closeVideo() {
      this.player.stopVideo();

      this.player.destroy();

      this.$emit('closed');
    },
    openVideo() {
      const closeIconHeight = 80;

      this.player = YouTubePlayer('yt-player', {
        height: window.innerHeight - closeIconHeight,
        width: window.innerWidth,
        playerVars: {
          fs: 0, // disable fullscreen button
          rel: 0, // disable related videos
          modestbranding: 1, // disable youtube logo
          iv_load_policy: 3, // disable video annotations
          disablekb: 1, // disable keyboard actions
        },
      });

      this.player.loadPlaylist({ list: this.videoPlaylistId });
    },
  },
});
